//! Retract Access (With Group) - under development
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

const deleteRetractableId = async (id, callback) => {
  try {
    const snapshot = await fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .orderByKey()
      .equalTo(id.toString())
      .once("value");

    if (!snapshot.exists()) {
      customLog("❌ No matching entry found for the provided ID.");

      callback(false);

      return;
    }

    snapshot.forEach(async (data) => {
      let language = "";

      // Fetch user's language
      const settingSnapshot = await fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .once("value");
      language = settingSnapshot.val().language;

      customLog("id " + id.toString());

      await fire
        .database()
        .ref("retractableSharingRegistry")
        .child(auth.currentUser.uid)
        .child(data.key)
        .remove();

      // Delete from registry using shareAccessToken
      const shareToken = data.val().shareAccessToken;
      const shareToUid = data.val().sharedToUID;
      const shareToEmail = data.val().sharedToEmail;
      const lockSerial = data.val().lockSerial;
      const isGroup =
        data.val().sharingMode === "NORMAL-GRP" ||
        data.val().sharingMode === "OTA-GRP" ||
        data.val().sharingMode === "MULTI-GRP" ||
        data.val().sharingMode === "MULTI-OTA-GRP";

      const fetchUrl =
        "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

      if (isGroup) {
        let superAdminID;

        const groupSnapshot = await fire
          .database()
          .ref("groupAccounts")
          .once("value");
        if (groupSnapshot.exists()) {
          groupSnapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();
            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                superAdminID = superAdmin.key;
              }
            }
          });
        }

        const groupManagementSnapshot = await fire
          .database()
          .ref("GroupManagement")
          .child(superAdminID)
          .child(auth.currentUser.uid)
          .child(shareToUid)
          .child("groupMembers")
          .once("value");

        if (groupManagementSnapshot.exists()) {
          groupManagementSnapshot.forEach((groupMember) => {
            const groupMemberData = groupMember.val();
            const emailOfSharedUser = groupMemberData.memberEmail;

            const dataToSend = {
              lockSerial: lockSerial,
              email: emailOfSharedUser,
              ownerUid: auth.currentUser.uid,
              language: language,
            };

            fetch(fetchUrl, {
              method: "POST",
              body: JSON.stringify(dataToSend),
            });
          });
        }

        await fire
          .database()
          .ref("GroupManagement")
          .child(superAdminID)
          .child(auth.currentUser.uid)
          .child(shareToUid)
          .child("groupLocks")
          .child(data.key)
          .remove();
      } else {
        const dataToSend = {
          lockSerial: lockSerial,
          email: shareToEmail,
          ownerUid: auth.currentUser.uid,
          language: language,
        };

        customLog("dataToSend", dataToSend);
        fetch(fetchUrl, {
          method: "POST",
          body: JSON.stringify(dataToSend),
        });

        const shareRef = fire.database().ref();
        const toDelete = [];
        const emailToUidCache = {}; // email -> UID
        const retractableCache = {}; // UID -> retractableSharingRegistry data

        // Step 1: Fetch all userLocks for the shareToUid
        const userLocksSnap = await shareRef
          .child("userLocks")
          .child(shareToUid)
          .once("value");
        const userLocks = userLocksSnap.val() || {};

        // Step 2: Fetch registeredUsersOnPlatform once and invert it to {email: uid}
        const usersSnap = await shareRef
          .child("registeredUsersOnPlatform")
          .once("value");
        const uidToEmailMap = usersSnap.val() || {};
        Object.entries(uidToEmailMap).forEach(([uid, email]) => {
          emailToUidCache[email] = uid;
        });

        // Step 3: Loop over userLocks and decide which to delete
        for (const [lockId, lockData] of Object.entries(userLocks)) {
          const shareAccessToken = lockData?.shareAccessToken;

          if (!shareAccessToken) {
            customLog(`❌ [SKIPPED] ${lockId} — no shareAccessToken`);
            continue;
          }

          if (shareAccessToken === shareToken) {
            customLog(`🗑️ [DELETE] ${lockId} — token matches`);
            toDelete.push(lockId);
            continue;
          }

          // shareAccessToken !== shareToken → check retractable registry
          const sharedByEmail = lockData?.sharedBy;

          if (!sharedByEmail) {
            customLog(`❌ [SKIPPED] ${lockId} — no sharedBy email`);
            continue;
          }

          const sharedByUid = emailToUidCache[sharedByEmail];

          if (!sharedByUid) {
            customLog(
              `❌ [SKIPPED] ${lockId} — UID not found for email: ${sharedByEmail}`
            );
            continue;
          }

          // Load retractableSharingRegistry/{sharedByUid} if not cached
          if (!retractableCache[sharedByUid]) {
            const retractableSnap = await shareRef
              .child("retractableSharingRegistry")
              .child(sharedByUid)
              .once("value");

            retractableCache[sharedByUid] = retractableSnap.val() || {};
            customLog(
              `📚 Loaded retractableSharingRegistry for ${sharedByUid}:`,
              retractableCache[sharedByUid]
            );
          }

          let foundMatch = false;
          // Check each shareAccessToken in retractableSharingRegistry for matching shareAccessToken
          for (const [hash, entry] of Object.entries(
            retractableCache[sharedByUid]
          )) {
            if (entry.shareAccessToken === shareAccessToken) {
              customLog(
                `✅ [KEEP] ${lockId} — token matches in retractableSharingRegistry`
              );
              foundMatch = true;
              break;
            }
          }

          if (!foundMatch) {
            customLog(
              `🗑️ [DELETE] ${lockId} — no matching shareAccessToken found in registry`
            );
            toDelete.push(lockId);
          }
        }

        // Step 4: Perform batch deletion
        if (toDelete.length > 0) {
          const updates = {};
          toDelete.forEach((lockId) => {
            updates[`userLocks/${shareToUid}/${lockId}`] = null;
          });

          await shareRef.update(updates);
          customLog(`🔥 Deleted ${toDelete.length} lock(s)`);
        } else {
          customLog("✅ No locks to delete.");
        }
      }
    });

    // Call the callback function with success status
    callback(true);
  } catch (err) {
    customLog(err);
    callback(false);
  }
};
// const deleteRetractableGroupId = async (payload, callback) => {
//   customLog("🟢 Deleting with payload:\n" + JSON.stringify(payload, null, 2));

//   try {
//     // your existing delete logic here...
//     callback(true);
//   } catch (err) {
//     customLog("❌ Error with payload:", payload, err);
//     callback(false);
//   }
// };

const deleteRetractableGroupId = async (payload, callback) => {
  try {
    // console.log("🟢 Function start: deleteRetractableGroupId");
    // console.log("📦 Payload received:", JSON.stringify(payload, null, 2));

    const pathRef = fire
      .database()
      .ref("lockGroupManagement")
      .child(payload.senderUID)
      .child(auth.currentUser.uid);

    // console.log("🔍 Firebase path for snapshot:", pathRef.toString());
    // console.log("🔑 Looking for lockId:", payload.lockId);

    const snapshot = await pathRef
      .orderByKey()
      .equalTo(payload.lockId.toString())
      .once("value");

    // console.log("📥 Snapshot raw value:", snapshot.val());

    if (!snapshot.exists()) {
      console.warn("❌ No matching entry found for lockId:", payload.lockId);
      callback(false);
      return;
    }

    for (const [key, data] of Object.entries(snapshot.val() || {})) {
      // console.log("🔑 Iterating entry:", key, "=>", data);

      let language = "en";
      try {
        const settingSnapshot = await fire
          .database()
          .ref("userSettings")
          .child(auth.currentUser.uid)
          .once("value");

        // console.log("🌐 User settings:", settingSnapshot.val());
        language = settingSnapshot.val()?.language || "en";
      } catch (err) {
        console.error("⚠️ Failed to fetch user settings:", err);
      }

      // === Delete sharedInstances entry ===
      try {
        const deletePath = fire
          .database()
          .ref("lockGroupManagement")
          .child(payload.senderUID)
          .child(auth.currentUser.uid)
          .child(payload.lockId)
          .child("sharedInstances")
          .child(payload.id);

        // console.log("🗑️ Deleting path:", deletePath.toString());
        await deletePath.remove();
        // console.log("✅ Deleted sharedInstance:", payload.id);
      } catch (err) {
        console.error("❌ Error removing sharedInstance:", err);
        throw err;
      }

      // // === State update ===
      // try {
      //   console.log("🔄 Updating state with removal of id:", payload.id);
      //   if (this?.setState) {
      //     this.setState((prevState) => ({
      //       locklistarray: prevState.locklistarray.filter(
      //         (item) => item.id !== payload.id
      //       ),
      //     }));
      //   } else {
      //     console.warn("⚠️ this.setState is undefined (are you inside a class component?)");
      //   }
      // } catch (err) {
      //   console.error("❌ Error during setState:", err);
      //   throw err;
      // }

      // === Email handling ===
      const fetchUrl =
        "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";
      let emails = [];

      const rawEmail = payload.sharedToEmail;
      const emailCandidate = (rawEmail || "").trim();
      const isEmail = /\S+@\S+\.\S+/.test(emailCandidate);

      if (isEmail) {
        // console.log("📧 Direct email detected:", emailCandidate);
        emails.push(emailCandidate);
      } else {
        // console.log("👥 Group detected, sharedToUID:", payload.sharedToUID);

        try {
          const groupSnapshot = await fire
            .database()
            .ref("GroupManagement")
            .child(payload.senderUID)
            .once("value");

          // console.log("📥 Group snapshot value:", groupSnapshot.val());

          if (!groupSnapshot.exists()) {
            // console.warn("⚠️ No groups found for superAdmin:", payload.senderUID);
          } else {
            let found = false;

            groupSnapshot.forEach((ownerSnap) => {
              const ownerID = ownerSnap.key;
              const groups = ownerSnap.val();

              // console.log("👤 Owner:", ownerID, "Groups:", groups);

              if (groups && groups[payload.sharedToUID]) {
                const group = groups[payload.sharedToUID];
                const members = group.groupMembers || {};

                emails = Object.values(members)
                  .map((m) => m.memberEmail)
                  .filter(Boolean);

                // console.log(
                  // `✅ Found ${emails.length} members in group ${payload.sharedToUID} under owner ${ownerID}:`,
                  // emails
                // );

                found = true;
              }
            });

            if (!found) {
              // console.warn(`⚠️ Group ${payload.sharedToUID} not found under any owner`);
            }
          }
        } catch (err) {
          console.error("❌ Error fetching group members:", err);
        }
      }

      // === Send retract email ===
      for (const email of emails) {
        const dataToSend = {
          lockSerial: payload.sharedLockName,
          email: email,
          ownerUid: auth.currentUser.uid,
          language: language,
        };

        // console.log("📤 Sending retract email:", dataToSend);
        // console.log("📤 Sending retract email:", JSON.stringify(dataToSend));

        try {
          const response = await fetch(fetchUrl, {
            method: "POST",
            body: JSON.stringify(dataToSend),
          });

          // console.log("📥 Email API response status:", response.status);
          const text = await response.text();
          // console.log("📥 Email API response body:", text);
        } catch (err) {
          console.error("❌ Error sending retract email:", err);
        }
      }
    }

    // console.log("✅ deleteRetractableGroupId completed successfully");
    callback(true);
  } catch (err) {
    console.error("❌ Error in deleteRetractableGroupId:", err, err?.stack);
    callback(false);
  }
};

export { deleteRetractableId };
export { deleteRetractableGroupId };
